module.exports = __webpack_public_path__ + "img/application.718c9725.svg";